export const SettingsOfflinePluginSettings: IPluginSettings = {
    name: 'Настройка офлайн режима',
    mnemocode: 'settings_offline_plugin',
    columns: []
  }